import React from "react";
import { Text } from "style/v2/components/Typography";
import { AssetCell, AssetLogo } from "./TopHoldings.styles";

const formatCurrency = (value) => {
  if (isNaN(value)) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(value);
};

const formatPercent = (value) => {
  if (isNaN(value)) return "0.00%";
  return `${(value * 100).toFixed(2)}%`;
};

export const columns = [
  {
    dataField: "asset",
    text: "Asset",
    props: {
      cell: ({ row }) => {
        return (
          <AssetCell>
            <AssetLogo
              src={row.original.asset.imageUrl}
              alt={row.original.asset.symbol}
            />
            <div>
              <Text variant="bodyMedium" weight="600">
                {row.original.asset.symbol}
              </Text>
              <Text variant="caption" color="muted">
                {row.original.asset.name}
              </Text>
            </div>
          </AssetCell>
        );
      },
    },
  },
  {
    dataField: "weight",
    text: "Weight",
    props: {
      cell: ({ getValue }) => (
        <Text variant="bodyMedium" color="secondary">
          {formatPercent(getValue())}
        </Text>
      ),
    },
  },
  {
    dataField: "sharePrice",
    text: "Share Price",
    props: {
      cell: ({ getValue }) => (
        <Text variant="bodyMedium" color="secondary">
          {formatCurrency(getValue())}
        </Text>
      ),
    },
  },
  {
    dataField: "industry",
    text: "Industry",
    props: {
      cell: ({ getValue }) => (
        <Text variant="body" color="secondary">
          {getValue()}
        </Text>
      ),
    },
  },
];
